<template>
    <div class="totallingTargetListContainer" :style="cssGridRows">
        <div class="totallingTargetListHeader">
            <input class="searchInputText" type="text" placeholder="グループ名 / 商品名 / 商品コード" v-model="searchKeyword">
            <slot name="header-action"></slot>
        </div>
        <div v-if="showSelected" class="selectedTotallingTarget">選択中商品グループ : {{ this.selectedTotallingTargets }}</div>
        <div class="totallingTargetList">
            <transition-group tag="ul" :style="cssValueListColumn">
                <li v-for="totallingTarget in this.dispTotattingTargets" :key="totallingTarget.id"
                    class="totallingTargetItem" :class="{ 'selected': totallingTarget.is_ranking_excluded === 1 }"
                    @click="selectTotallingTarget(totallingTarget)">
                    <div>{{ totallingTarget.name }}
                        <span v-if="totallingTarget.products.length > 1">（{{ totallingTarget.products.length
                            }}商品）</span>
                    </div>
                    <div class="listItemAction">
                        <slot name="list-item-action" :totallingTarget="totallingTarget"></slot>
                    </div>
                </li>
            </transition-group>
            <transition>
                <div v-if="this.dispTotattingTargets.length == 0" class="noData">
                    該当する商品がありません。
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';

export default {
    data() {
        return {
            searchKeyword: '',
            filterKeyword: '',
        }
    },
    props: {
        value: Number,
        customFilter: Function,
        totallingTargets: Array,
        returnObject: {
            type: Boolean,
            default: false,
        },
        showSelected: {
            type: Boolean,
            default: false,
        },
        listColumn: {
            type: Number,
            default: 1,
        },
        addFetchParameters: {
            type: Object,
            default: null,
        },
    },
    mounted: function () {
    },
    methods: {
        selectTotallingTarget(totallingTarget) {
            if (totallingTarget.is_ranking_excluded === 1) {
                totallingTarget.is_ranking_excluded = 0;
            } else {
                totallingTarget.is_ranking_excluded = 1;
            }
        },
    },
    watch: {
        searchKeyword: _.debounce(function (newVal) {
            this.filterKeyword = newVal.toKeyword();
        },
            500
        ),
    },
    computed: {
        selectedTotallingTargets: function () {
            var cnt = 0;
            for (var tt of this.totallingTargets) {
                if (tt.is_ranking_excluded === 1) {
                    cnt++;
                }
            }
            return cnt;
        },
        dispTotattingTargets: function () {
            let totattingTargets = this.totallingTargets.map(totallingTarget => {
                const productKeywords = totallingTarget.products.map(
                    product => `${product.id} ${product.name}`.toKeyword()
                ).join(' ');

                totallingTarget._keyword = `${totallingTarget.name} ${productKeywords}`.toKeyword();
                return totallingTarget;
            });

            if (this.customFilter) {
                totattingTargets = _.filter(totattingTargets, this.customFilter);
            }

            if (this.filterKeyword) {
                const filterKeywordLower = this.filterKeyword.toLowerCase();
                totattingTargets = _.filter(totattingTargets, (totattingTarget) => {
                    return totattingTarget._keyword.toLowerCase().indexOf(filterKeywordLower) > -1;
                });
            }

            return totattingTargets;
        },
        cssGridRows: function () {
            if (this.showSelected) {
                return `grid-template-rows: 44px 30px 1fr`;
            } else {
                return `grid-template-rows: 44px 1fr`;
            }
        },
        cssValueListColumn: function () {
            return `--column: ${this.listColumn}`;
        },
    }
}
</script>

<style scoped lang="sass">
.totallingTargetListContainer
    padding: 0
    height: 100%
    width: 100%
    display: inline-grid
    grid-template-columns: 1fr
    grid-row-gap: 10px
    //grid-template-rows: 44px 30px 1fr
    .totallingTargetListHeader
        overflow: hidden
        padding: 0
        .searchInputText
            display: block
            float: left
            padding: 10px
            width: 30%
            min-width: 250px
            margin: 2px
            &:focus
                outline: 2px solid $mainColor
    .selectedTotallingTarget
        border-bottom: 2px solid #E6E6E6
        color: $grayColor
        font-size: 1.5rem
        height: 30px
        margin: 0
        padding: 7px
        width: 30%
        min-width: 250px
    .totallingTargetList
        color: $grayColor
        font-size: 1.5rem
        overflow-y: scroll
        margin: 0
        padding: 0
        ul
            display: flex
            flex-wrap: wrap
            --column: 4
            li
                overflow: hidden
                display: inline-flex
                align-items: center
                margin: 2px
                padding: 7px 2px
                width: calc(100% / var(--column) - 4px)
                height: 40px
                background: #f5f5f5
                white-space: nowrap
                cursor: pointer
                position: relative
                &:hover
                    background: $mainColor
                    color: $whiteColor
                    transition: 0.2s ease-out
                .majorPanel
                    width: 26px
                    height: 26px
                    line-height: 26px
                    font-size: 16px
                    text-align: center
                    display: inline-block
                    transition: all .3s ease 0s
                    &.majorSelected
                        color: #ff9e00
                    &:hover
                        transform: scale(1.6)
                .listItemAction
                    position: absolute
                    right: 2px
                &.v-leave-active
                    position: absolute
        .noData
            height: 50%
            display: grid
            place-items: center
        .v-enter-active, .v-leave-active, .v-move
            transition: all 0.4s
        .v-enter, .v-leave-to
            opacity: 0
        .selected
            background: $mainColor
            color: $whiteColor
            opacity: 0.5

@include sp() 
    .totallingTargetListContainer
        margin-top: 30px
        .totallingTargetItem
            padding: 0 10px !important
            font-size: 12px
</style>
